module.exports = __webpack_public_path__ + "img/code.09fdd434.png";